module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Dialog', {
    style: ({
      width: '500px'
    }),
    attrs: {
      "visible": _vm.dialogVisible,
      "header": _vm.clientName
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "show": _vm.checkNepaliDateOrEnglishNext
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button p-button-raised p-button-primary",
          attrs: {
            "label": "Save",
            "icon": "pi pi-check"
          },
          on: {
            "click": _vm.saveRemarks
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button p-button-raised p-button-danger",
          attrs: {
            "label": "Cancel",
            "icon": "pi pi-times"
          },
          on: {
            "click": _vm.closeDialog
          }
        })]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "remarks"
    }
  }, [_vm._v("Remarks "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('Textarea', {
    attrs: {
      "id": "remarks",
      "rows": "3",
      "autoResize": ""
    },
    model: {
      value: (_vm.remarksData.remarks),
      callback: function($$v) {
        _vm.$set(_vm.remarksData, "remarks", $$v)
      },
      expression: "remarksData.remarks"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "remarks1"
    }
  }, [_vm._v("Remarks 1")]), _vm._v(" "), _c('Textarea', {
    attrs: {
      "id": "remarks1",
      "rows": "3",
      "autoResize": ""
    },
    model: {
      value: (_vm.remarksData.remarks1),
      callback: function($$v) {
        _vm.$set(_vm.remarksData, "remarks1", $$v)
      },
      expression: "remarksData.remarks1"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "remarks2"
    }
  }, [_vm._v("Remarks 2")]), _vm._v(" "), _c('Textarea', {
    attrs: {
      "id": "remarks2",
      "rows": "3",
      "autoResize": ""
    },
    model: {
      value: (_vm.remarksData.remarks2),
      callback: function($$v) {
        _vm.$set(_vm.remarksData, "remarks2", $$v)
      },
      expression: "remarksData.remarks2"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-lg-6 p-xl-2"
  }, [_c('label', [_vm._v("Next Follow-up Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    ref: "nxt",
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.nextFollowUpDate),
      callback: function($$v) {
        _vm.nextFollowUpDate = $$v
      },
      expression: "nextFollowUpDate"
    }
  }) : _c('input-mask', {
    ref: "nxt",
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "id": "nextFollowUpDate",
      "append-to-body": true
    },
    model: {
      value: (_vm.nextFollowUpDate),
      callback: function($$v) {
        _vm.nextFollowUpDate = $$v
      },
      expression: "nextFollowUpDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-lg-6 p-xl-2"
  }, [_c('label', [_vm._v("Follow-up Time")]), _vm._v(" "), _c('Calendar', {
    attrs: {
      "id": "followUpTime",
      "timeOnly": true,
      "showSeconds": false,
      "hourFormat": '24',
      "showIcon": true,
      "stepMinute": 5,
      "placeholder": "Select Time"
    },
    model: {
      value: (_vm.remarksData.followUpTime),
      callback: function($$v) {
        _vm.$set(_vm.remarksData, "followUpTime", $$v)
      },
      expression: "remarksData.followUpTime"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-608f36ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/crm/RemarksDialog.vue
// module id = 2265
// module chunks = 0